import { ReactComponent as Algorithm } from "./../assets/svgs/algorithm.svg";
import { ReactComponent as FitIntegrations } from "./../assets/svgs/fit-integrations.svg";
import { ReactComponent as GPTAgent } from "./../assets/svgs/gpt-agent.svg";
import { ReactComponent as EmailAgent } from "./../assets/svgs/email-agent.svg";
import ContactFaqSection from "../components/ContactFaqSection.js";
import FeatureTile from "../components/FeatureTile.js";
import seoHeroImage from "./../assets/seo-hero-image.png";
import Navbar from "../components/Navbar.js";
import { landingDesktopItems, landingMobileItems } from "./../data/mockData.js";
import B2BContactLeadForm from "../components/B2BContactLeadForm.js";
import { Link } from "react-router-dom";
import AISizingSoftwareSections from "../components/AISizingSoftwareSections.js";

const AiSizingSoftware = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Top bar */}
      <Navbar
        desktopItems={landingDesktopItems}
        mobileItems={landingMobileItems}
      />
      {/* Hero */}
      <main>
        <section className="pt-12 pb-10 px-[32px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
            <div className="order-1 lg:order-2 lg:justify-self-end w-full justify-items-end">
              <div className="w-full max-w-[688px] h-[420px] sm:h-[617px] rounded-[10px] border overflow-hidden relative bg-gradient-to-br from-[#E8D7D1] via-[#F0B5A9] to-[#B25B5B]">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-[70%] sm:w-[37%] h-[62%] rounded-[14px] flex items-center justify-center">
                    <img
                      src={seoHeroImage}
                      alt="Eveness solutions hero"
                      className="w-full h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                </div>

                <div className="absolute -top-20 -right-24 w-72 h-72 rounded-full bg-white/10 blur-2xl" />
              </div>
            </div>

            {/* Left (content) should be below on mobile */}
            <div className="order-2 lg:order-1 max-w-[900px]">
              <h2 className="md:leading-[48px] text-black font-medium md:text-[48px] text-[34px] leading-[40px] tracking-[-1.6px] align-middle font-helvena">
                AI Shopping Experience for smarter, faster revenue growth
              </h2>
              <p className="mt-[30px] max-w-[420px] font-normal text-[13px] leading-[18px] tracking-[0.17px] align-middle text-[#1A1A1A]">
                To unlock your own branded GPT, advanced fit &amp; style
                solutions, and a recommendation algorithm that reorders your
                collection pages to reduce returns, please{" "}
                <Link
                  to="/get-started"
                  className="text-[#1A1A1A] hover:text-black font-normal text-[13px] leading-[18px] tracking-[0.17px] align-middle underline decoration-solid"
                >
                  get in touch.
                </Link>
              </p>
              <B2BContactLeadForm className="mt-[30px]" />
            </div>
          </div>
        </section>

        {/* Features row */}
        <section className="pb-14 px-[32px]">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
            <FeatureTile
              title="Fit and Try-on Integrations"
              desc="Automated product descriptions and SEO metadata."
              Icon={FitIntegrations}
            />
            <FeatureTile
              title="GPT Sales Agent"
              desc="AI-powered sales assistant for your customers."
              Icon={GPTAgent}
            />
            <FeatureTile
              title="Recommender Algorithm"
              desc="Data-driven insights to boost your sales performance."
              Icon={Algorithm}
            />
            <FeatureTile
              title="SMS and Email Marketing Tools"
              desc="Targeted campaigns based on your actual customers' fit and style preferences"
              Icon={EmailAgent}
            />
          </div>
        </section>

        {/* Animated videos section */}
        <AISizingSoftwareSections />
        {/* Contact + FAQ section */}
        <ContactFaqSection source="SEO" />
      </main>
    </div>
  );
};

export default AiSizingSoftware;
